import { useQuery } from "react-query";
import { getCameraTypes2 } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useCameraTypes2 = () => {
  const { data, isLoading, refetch } = useQuery(
    "GetCameraTypes2",
    getCameraTypes2,
    {
      refetchOnWindowFocus: false,
    }
  );

  return { data, isLoading, refetch };
};
